module.exports = __webpack_public_path__ + "static/media/file.7bb73027.svg";